import {OK, CREATED, UNPROCESSABLE_ENTITY, setCookie} from "../util";

const state = {
    inviteErrorsMessages: null,
    tempInviteStatus: null,
    tokenStatus: null,
}

const getters = {
}

const mutations = {
    setInviteStatus(state, status) {
        state.tempInviteStatus = status
    },
    setTokenStatus(state, status) {
        state.tokenStatus = status
    },
    setToken (state, user) {
        setCookie('token', user.token, 2)
        state.token = user.token
    },
    setInviteErrorsMessages(state, messages) {
        state.inviteErrorsMessages = messages
    },
}

const actions = {
    // 招待からの仮登録、メール送信
    async create (context, data) {
        context.commit('setInviteStatus', false)
        const response = await axios.post('/api/invite/create', data)

        if (response.status === CREATED) {
            context.commit('setInviteStatus', true)
            return false
        }

        if (response.status === UNPROCESSABLE_ENTITY) {
            context.commit('setInviteErrorsMessages', response.data.errors)
        } else {
            context.commit('error/setCode', response.status, { root: true })
        }
    },
    async checkInviteToken(context, data) {
        const response = await axios.post('/api/invite/check_token', data)

        if (response.status === OK) {
            context.commit('setTokenStatus', true)
            return false
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}